module.exports = "<!-- <loader class=\"page-loader\" [isLoading]=\"true\" *ngIf=\"isError != true && actType == ''\"></loader> -->\n<alg-assistance\n  *ngIf=\"isError\"\n  title=\"Abbiamo riscontrato un problema. Contatta il nostro numero verde per maggiori informazioni\">\n</alg-assistance>\n\n<alg-consenso *ngIf=\"actType == 'Switch-In'\"></alg-consenso>\n<alg-attivazioni *ngIf=\"actType == 'Nuova Attivazione'\"></alg-attivazioni>"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/alg-switch-page/alg-switch-page.component.html
// module id = ./src/app/pages/alg-switch-page/alg-switch-page.component.html
// module chunks = main